import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeading from "components/shared/PageHeading";
import EntityTable from "components/shared/EntityTable";
import {
  entityTitleColumn,
  memberCountColumn,
} from "components/shared/entityColumns";
import { useTranslation } from "react-i18next";

const UserClassAndGroups = ({ classes, groups, isLoading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const classList = Array.isArray(classes) ? classes : classes ? [classes] : [];

  return (
    <>
      <PageHeading heading={"Classes & Groups"} />
      <div>
        {/* Classes Section */}
        <div className="d-flex justify-content-between mt-4 mb-2">
          <PageHeading heading={t("Classes")} />
        </div>
        <EntityTable
          loading={isLoading}
          loadingRows={3}
          items={classList}
          emptyLabel={t("No classes joined yet.")}
          onRowClick={(c) => navigate(`/classes/${c._id}`)}
          columns={[entityTitleColumn(t), memberCountColumn(t)]}
        />

        {/* Groups Section */}
        <div className="d-flex justify-content-between mt-4 mb-2">
          <PageHeading heading={"Groups"} />
        </div>
        <EntityTable
          loading={isLoading}
          loadingRows={3}
          items={groups || []}
          emptyLabel={t("No groups joined yet.")}
          onRowClick={(g) => navigate(`/groups/${g._id}`)}
          columns={[
            entityTitleColumn(t, { isGroup: true }),
            memberCountColumn(t),
          ]}
        />
      </div>
    </>
  );
};

export default UserClassAndGroups;
